import { render, staticRenderFns } from "./ShipmentBatchPreview.vue?vue&type=template&id=dc97b00a&scoped=true&"
import script from "./ShipmentBatchPreview.vue?vue&type=script&lang=js&"
export * from "./ShipmentBatchPreview.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentBatchPreview.vue?vue&type=style&index=0&id=dc97b00a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc97b00a",
  null
  
)

export default component.exports